<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="col-md-12">
					<project-type-form v-if="showProjectTypeForm"
						:edit-mode="editMode"
						:project-type-prop="type"
						:project-type-id="projectTypeId"
						:pre-created-assignments-prop="preCreatedAssignments"
						@close="closeProjectTypeForm"
						@refreshData="fetchProjectTypeData"
					></project-type-form>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<card :title="$t('projectTypes.projectTypes')" :on-add-object="openProjectTypeForm">
					<div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
						<div class="col-12 col-md-4 col-sm-6 mb-2">
							<el-input
								v-model="searchQuery"
								class="search-input"
								clearable
								:prefix-icon="Search"
								:placeholder="$t('common.searchRecords')"
								aria-controls="datatables"
								@keyup="search"
								@clear="handleClearSearch"
							/>
						</div>
					</div>
					<div v-if="tableDataReady">
						<div class="table-responsive">
							<el-base-table
								:table-data="tableData.data"
								:table-columns="tableData.columns"
								:actions-inline="true"
								:enable-edit="true"
								@edit="handleProjectTypeEdit"
							/>
						</div>
					</div>
				</card>
			</div>
		</div>
	</div>
</template>
<script>
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';
import api from "../../services/api";  // Import your API service
import ElBaseTable from "../../components/ElBaseTable.vue";
import { getCustomerConfig } from '../Settings/customerConfigHelper';
import ProjectTypeForm from "./ProjectTypeForm";
import Card from '../../components/Card.vue';
import { Search } from '@element-plus/icons-vue';


export default {
	components: {
		ProjectTypeForm,
    	'el-base-table': ElBaseTable,
		Card
	},
	data() {
	return {
		Search,
		pagination: {
			perPage: 10,
			currentPage: 1,
			total: 0
		},
		isMobile: window.innerWidth <= 1024,
		tableData: {},
		tableDataReady: false,
		searchQuery: '',
		type: '',
		projectTypeId: 0,
		preCreatedAssignments: false,
		showProjectTypeForm: false,
		editMode: false
	}
	},
	computed: {
		pagination_to() {
			let highBound = this.pagination_from + this.pagination.perPage;
			if (this.pagination_total < highBound) {
				highBound = this.pagination_total;
			}
			return highBound;
		},
		pagination_from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
		pagination_total() {
			return this.pagination.total;
		},
	},
	created() {
    	window.addEventListener('resize', this.updateIsMobile);
		const token = Cookies.get('accessToken');
		const decodedToken = jwtDecode(token);
		this.userRole = decodedToken.role;
		getCustomerConfig('DefaultPageSize')
		.then(config => {
			if(config === '') {
				this.pagination.perPage = 10
			}
			else {
				this.pagination.perPage = config
			}
			this.fetchProjectTypeData();  // Fetch the table data
		})
	},
	beforeUnmount() {
    	window.removeEventListener('resize', this.updateIsMobile);
  	},
	methods: {
		updateIsMobile() {
			this.isMobile = window.innerWidth <= 1024;
		},
		async fetchProjectTypeData() {
			this.tableData = {
				columns: [
				{ prop: 'type', label: this.$t('projectTypes.projectType'), minWidth: 120, showOnMobile: true },
				{ prop: 'preCreatedAssignmentsText', label: this.$t('projectTypes.preCreatedAssignments'), minWidth: 120, showOnMobile: true }
				],
        		data: [],
      		}

			try {
				let projectTypeUrl = `/ProjectType?type=${this.searchQuery}`
        		const response = await api.get(projectTypeUrl);
        		// this.pagination.total = response.data.totalItems;
				this.tableData.data = response.data.map(item => {
				return {
					id: item.id,
					type: item.type,
					preCreatedAssignments: item.preCreatedAssignments,
					preCreatedAssignmentsText: item.preCreatedAssignments ? this.$t('common.yes') : this.$t('common.no') ,
				};
			});
				this.tableDataReady = true;
			} catch (error) {
				console.error('API request error:', error); // eslint-disable-line no-console
				this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
			}
		},
		handleClearSearch() {
			this.fetchProjectTypeData();
		},
		search(event) {
			this.pagination.currentPage = 1;
        const queryLength = this.searchQuery.length;
        if (event.key === 'Backspace' || event.key === 'Enter') {
          this.fetchProjectTypeData();
        }
        else {
          if (queryLength > 1) {
            if (queryLength % 2 === 0) {
              this.fetchProjectTypeData();
            }
          }
        }
		},
		handleProjectTypeEdit(index, row) {
			this.editMode = true;
			this.type = row.type;
      		this.preCreatedAssignments = row.preCreatedAssignments;
			this.projectTypeId = row.id;
			this.openProjectTypeForm();
		},
		openProjectTypeForm() {
			this.showProjectTypeForm = true;
			this.$nextTick(() => {
				window.scrollTo(0, 0);
			});
  		},
		closeProjectTypeForm() {
			this.showProjectTypeForm = false;
			this.type = '';
			this.projectTypeId = 0;
			this.preCreatedAssignments = false;
			this.editMode = false;
		},
	},
	
};
</script>
<style>
</style>

